export default "__VITE_ASSET__DdCAVCF6__"